// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l5Gf7","importantInfo":"styles_importantInfo__3htBh"};